import * as types from "./types";

function userLogin(payload) {
  return { type: types.USER_LOGIN };
}
function userLogged(payload) {
  return { type: types.USER_LOGGED, payload };
}

function loginError(error) {
  return { type: types.ERROR, error };
}

function userLogOut() {
  return { type: types.USER_LOGOUT };
}

function userAdmin(payload) {
  return { type: types.USER_IS_ADMIN, payload };
}

function userNormal(payload) {
  return { type: types.USER_IS_NORMAL, payload };
}

function resetUserType() {
  return { type: types.RESET_USER_TYPE };
}

function resetError() {
  return { type: types.RESET_ERROR };
}

export {
  userLogin,
  userLogged,
  loginError,
  userLogOut,
  userAdmin,
  userNormal,
  resetUserType,
  resetError
};



// WEBPACK FOOTER //
// ./src/ducks/login/actions.js